import { ComponentProps, FC } from 'react';
import { DetailPage } from 'modules/detailPage/components/DetailPage';
import { DetailPagePlaceholderHeader } from 'modules/detailPage/components/DetailPagePlaceholder/DetailPagePlaceholderHeader';
import { DetailPageTabsPlaceholder } from './DetailPageTabsPlaceholder';

type DetailPagePlaceholderProps = {
	tabsProps?: ComponentProps<typeof DetailPageTabsPlaceholder>;
	headerProps?: ComponentProps<typeof DetailPagePlaceholderHeader>;
};

const DetailPagePlaceholder: FC<DetailPagePlaceholderProps> = ({ tabsProps, headerProps }) => {
	return (
		<DetailPage>
			<DetailPagePlaceholderHeader {...headerProps} />
			<DetailPage.Content>
				<DetailPageTabsPlaceholder
					tabsCount={5}
					{...tabsProps}
				/>
			</DetailPage.Content>
		</DetailPage>
	);
};

export { DetailPagePlaceholder };
